// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.93.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.93.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cards {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
      flex-wrap: wrap;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  gap: 10px;
  margin: 0 auto;
  max-width: 90lvw;
}

.card-info {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  padding: 15px 15px 15px 20px;
  background: #ebebeb;
  color: #454545;
  border-radius: 5px;
  font-size: 15px;
  gap: 1em;
}
.card-info > div {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
  gap: 5px;
}
.card-info > div:first-child {
  width: 9em;
}
.card-info > div:last-child {
  width: 10em;
}
.card-info header {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
      -ms-flex-pack: justify;
          justify-content: space-between;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
  margin-bottom: 1em;
  margin-top: 0.5em;
  gap: 5px;
}
.card-info header h2 {
  font-size: 1.2em;
  font-weight: bold;
}
.card-info header small {
  font-size: 0.8em;
  color: #666;
}
.card-info main {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
  gap: 5px;
}
.card-info main > div {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  min-width: 80%;
  -ms-flex-wrap: wrap;
      flex-wrap: wrap;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: reverse;
      -ms-flex-direction: row-reverse;
          flex-direction: row-reverse;
  -webkit-box-pack: start;
      -ms-flex-pack: start;
          justify-content: start;
  gap: 10px;
}
.card-info main > div > :last-child {
  min-width: 13px;
  text-align: right;
  -webkit-font-feature-settings: "tnum";
          font-feature-settings: "tnum";
  font-variant-numeric: tabular-nums;
}`, "",{"version":3,"sources":["webpack://./src/screens/cards.scss"],"names":[],"mappings":"AAAA;EACE,oBAAA;EAAA,oBAAA;EAAA,aAAA;EACA,mBAAA;MAAA,eAAA;EACA,wBAAA;MAAA,qBAAA;UAAA,uBAAA;EACA,SAAA;EACA,cAAA;EACA,gBAAA;AACF;;AAEA;EACE,oBAAA;EAAA,oBAAA;EAAA,aAAA;EACA,4BAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;EACA,QAAA;AACF;AACE;EACE,oBAAA;EAAA,oBAAA;EAAA,aAAA;EACA,4BAAA;EAAA,6BAAA;MAAA,0BAAA;UAAA,sBAAA;EACA,QAAA;AACJ;AACI;EACE,UAAA;AACN;AAEI;EACE,WAAA;AAAN;AAIE;EACE,oBAAA;EAAA,oBAAA;EAAA,aAAA;EACA,yBAAA;MAAA,sBAAA;UAAA,8BAAA;EACA,4BAAA;EAAA,6BAAA;MAAA,0BAAA;UAAA,sBAAA;EACA,kBAAA;EACA,iBAAA;EACA,QAAA;AAFJ;AAII;EACE,gBAAA;EACA,iBAAA;AAFN;AAKI;EACE,gBAAA;EACA,WAAA;AAHN;AAOE;EACE,oBAAA;EAAA,oBAAA;EAAA,aAAA;EACA,4BAAA;EAAA,6BAAA;MAAA,0BAAA;UAAA,sBAAA;EACA,QAAA;AALJ;AAOI;EACE,oBAAA;EAAA,oBAAA;EAAA,aAAA;EACA,cAAA;EACA,mBAAA;MAAA,eAAA;EACA,8BAAA;EAAA,8BAAA;MAAA,+BAAA;UAAA,2BAAA;EACA,uBAAA;MAAA,oBAAA;UAAA,sBAAA;EACA,SAAA;AALN;AAOM;EACE,eAAA;EACA,iBAAA;EACA,qCAAA;UAAA,6BAAA;EAAA,kCAAA;AALR","sourcesContent":[".cards {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: 10px;\n  margin: 0 auto;\n  max-width: 90lvw;\n}\n\n.card-info {\n  display: flex;\n  padding: 15px 15px 15px 20px;\n  background: #ebebeb;\n  color: #454545;\n  border-radius: 5px;\n  font-size: 15px;\n  gap: 1em;\n\n  & > div {\n    display: flex;\n    flex-direction: column;\n    gap: 5px;\n\n    &:first-child {\n      width: 9em;\n    }\n\n    &:last-child {\n      width: 10em;\n    }\n  }\n\n  header {\n    display: flex;\n    justify-content: space-between;\n    flex-direction: column;\n    margin-bottom: 1em;\n    margin-top: 0.5em;\n    gap: 5px;\n\n    h2 {\n      font-size: 1.2em;\n      font-weight: bold;\n    }\n\n    small {\n      font-size: 0.8em;\n      color: #666;\n    }\n  }\n\n  main {\n    display: flex;\n    flex-direction: column;\n    gap: 5px;\n\n    & > div {\n      display: flex;\n      min-width: 80%;\n      flex-wrap: wrap;\n      flex-direction: row-reverse;\n      justify-content: start;\n      gap: 10px;\n\n      > :last-child {\n        min-width: 13px;\n        text-align: right;\n        font-variant-numeric: tabular-nums;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
